import { createI18n } from 'vue-i18n';
import it from './locales/it.json';
import de from './locales/de.json';
import en from './locales/en.json';

export type SupportedLocale = 'it' | 'de' | 'en';

// Rileva la lingua iniziale dall'URL o dal localStorage
const detectInitialLocale = (): SupportedLocale => {
	// Prima controlla l'URL
	if (window.location.pathname.startsWith('/de/')) {
		return 'de';
	}
	if (window.location.pathname.startsWith('/en/')) {
		return 'en';
	}
	// Poi controlla il localStorage
	const saved = localStorage.getItem('locale') as SupportedLocale | null;
	if (saved && (saved === 'it' || saved === 'de' || saved === 'en')) {
		return saved;
	}
	// Default italiano
	return 'it';
};

const i18n = createI18n({
	legacy: false, // Usa Composition API
	locale: detectInitialLocale(),
	fallbackLocale: 'it',
	messages: {
		it,
		de,
		en,
	},
});

export default i18n;
